export default "__VITE_ASSET__CUB94cSN__"